// extracted by mini-css-extract-plugin
module.exports = {"md":"feedback_md_3V5TM","ios":"feedback_ios_3KBxy"};